export const facilityTypes = {
  Undefined: '0',
  Hall: '1',
  Gym: '2',
  Studio: '3',
  Arena: '4',
  Stadium: '5',
  Swimming: '6',
  Location: '7'
};


export const mappedFacilityTypes = Object.entries(facilityTypes)
  .map(([key]) => ({ value: key, label: key }));